// modules/report/configs/reportFilter.config.ts
import { FilterFieldConfig } from "types/FilterFieldConfig";
import { REPORT_STATUS, REPORT_TYPE } from "../enums/report.enum";

// Helper lấy tất cả giá trị của enum (string enum)
function getEnumValues<T extends Record<string, string>>(
  enumObj: T,
): T[keyof T][] {
  return Object.keys(enumObj).map((key) => enumObj[key as keyof T]);
}

export const buildReportFilterFields = (): FilterFieldConfig<{
  status: string;
  report_type: string;
}>[] => {
  return [
    {
      key: "status",
      label: "Trạng thái",
      type: "select",
      options: getEnumValues(REPORT_STATUS).map((s) => ({
        label:
          s === "pending"
            ? "Đang chờ"
            : s === "resolved"
              ? "Đã xử lý"
              : "Từ chối",
        value: s,
      })),
      placeholder: "Tất cả trạng thái",
    },
    {
      key: "report_type",
      label: "Loại",
      type: "select",
      options: getEnumValues(REPORT_TYPE).map((t) => ({
        label:
          t === "post"
            ? "Bài viết"
            : t === "comment"
              ? "Bình luận"
              : t === "profile"
                ? "Hồ sơ"
                : "Phản hồi",
        value: t,
      })),
      placeholder: "Tất cả loại",
    },
  ];
};
